export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_SIRE_6.2dafca9c.jpg";